import {
    createContext
} from "react";
import type {
    ThemeSwitcherIconContextType
} from "./type";

export const ThemeSwitcherIconContext = createContext<ThemeSwitcherIconContextType>({
    isCustomIconColor: false,
    isDisabled: false
});
